'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularCookies = require('angular-cookies');

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularResource = require('angular-resource');

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularSanitize = require('angular-sanitize');

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularUiBootstrap = require('angular-ui-bootstrap');

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

require('angular-validation-match');

var _ngTagsInput = require('ng-tags-input');

var _ngTagsInput2 = _interopRequireDefault(_ngTagsInput);

require('angular-bootstrap-contextmenu');

var _app = require('./app.config');

var _auth = require('../components/auth/auth.module');

var _auth2 = _interopRequireDefault(_auth);

var _account = require('./account');

var _account2 = _interopRequireDefault(_account);

var _admin = require('./admin');

var _admin2 = _interopRequireDefault(_admin);

var _calendar = require('./calendar');

var _calendar2 = _interopRequireDefault(_calendar);

var _navbar = require('../components/navbar/navbar.component');

var _navbar2 = _interopRequireDefault(_navbar);

var _main = require('./main/main.component');

var _main2 = _interopRequireDefault(_main);

var _app2 = require('./app.constants');

var _app3 = _interopRequireDefault(_app2);

var _util = require('../components/util/util.module');

var _util2 = _interopRequireDefault(_util);

var _modal = require('../components/modal/modal.service');

var _modal2 = _interopRequireDefault(_modal);

var _filters = require('../components/filters/');

var _filters2 = _interopRequireDefault(_filters);

var _miscServices = require('../components/misc-services/');

var _miscServices2 = _interopRequireDefault(_miscServices);

require('./app.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('calApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _auth2.default, _account2.default, _admin2.default, 'validation.match', _navbar2.default, _main2.default, _app3.default, _util2.default, _calendar2.default, _filters2.default, _modal2.default, 'ngTagsInput', 'ui.bootstrap.contextMenu', _miscServices2.default]).config(_app.routeConfig).run(function ($rootScope, $location, Auth) {
  'ngInject';

  $rootScope.$on('$stateChangeStart', function (event, next) {
    Auth.isLoggedIn(function (loggedIn) {
      if (next.authenticate && !loggedIn) {
        $location.path('/');
      }
    });
  });
});

_angular2.default.element(document).ready(function () {
  _angular2.default.bootstrap(document, ['calApp'], {
    strictDi: true
  });
});


// WEBPACK FOOTER //
// ./client/app/app.js